// utils/socketGuards.js
export const safeThrottle = (() => {
  const last = new Map(); // key = event + tableId
  return (socket, event, payload, ms = 2000) => {
    if (!socket || typeof socket.emit !== 'function') {
      console.warn('[safeThrottle] ❌ socket невалидный или не передан:', socket);
      return;
    }

    const key = `${event}:${payload}`;
    const now = Date.now();
    if (now - (last.get(key) || 0) < ms) return;
    last.set(key, now);
    socket.emit(event, payload);
  };
})();
